module.exports = __webpack_public_path__ + "img/event-session-coaching-2024.25daae9.jpg";